// Shared input formatters / validators, used across all forms.

// Auto-format phone number as user types: "1234567890" → "123-456-7890"
export function formatPhoneInput(val) {
  const digits = (val || "").replace(/\D/g, "");
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6,10)}`;
}

// Keep only digits; optional max length.
export function onlyDigits(value, max) {
  const d = (value || "").replace(/\D/g, "");
  return max ? d.slice(0, max) : d;
}

// Constrain to valid currency: digits + at most one dot + at most 2 decimals.
export function onlyMoney(value) {
  let v = (value || "").replace(/[^\d.]/g, "");
  const firstDot = v.indexOf(".");
  if (firstDot !== -1) {
    v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, "");
    const [int, dec] = v.split(".");
    v = int + "." + dec.slice(0, 2);
  }
  return v;
}

// Phone is empty (optional) or a complete 10-digit number.
export function isValidPhone(value) {
  const d = (value || "").replace(/\D/g, "");
  return d.length === 0 || d.length === 10;
}

// Zip is empty (optional) or exactly 5 digits.
export function isValidZip(value) {
  const d = (value || "").replace(/\D/g, "");
  return d.length === 0 || d.length === 5;
}

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA",
  "KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT",
  "VA","WA","WV","WI","WY","DC",
];

// Common US timezones for the business-profile picker (IANA id → label).
export const US_TIMEZONES = [
  ["America/New_York",    "Eastern (New York)"],
  ["America/Chicago",     "Central (Chicago)"],
  ["America/Denver",      "Mountain (Denver)"],
  ["America/Phoenix",     "Arizona (Phoenix)"],
  ["America/Los_Angeles", "Pacific (Los Angeles)"],
  ["America/Anchorage",   "Alaska (Anchorage)"],
  ["Pacific/Honolulu",    "Hawaii (Honolulu)"],
];
// The browser's current IANA timezone (falls back to Eastern).
export const detectedTz = () => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York"; } catch { return "America/New_York"; } };
// US_TIMEZONES, but guaranteeing `current` is selectable even if outside the common list.
export const tzOptionsFor = (current) => (US_TIMEZONES.some(([v]) => v === current) ? US_TIMEZONES : [[current, current], ...US_TIMEZONES]);
